import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Gesture
import { StopGestureDirective } from './stop-gesture/stop-gesture.directive';

const DIRECTIVES = [StopGestureDirective];

@NgModule({
  declarations: DIRECTIVES,
  imports: [CommonModule],
  exports: DIRECTIVES,
})
export class DirectivesModule {}
